import cloneDeep from 'lodash/cloneDeep';
import { hasOwnProperty } from '@softgames/type-guards';
import type { AppRemoteConfig, RawAppRemoteConfig } from '../platform/Platform';

export const baseAppRemote: AppRemoteConfig = {
  app: {
    allowCheatOption: false,
    forceUpdateVersion: '1.10.0',
    optionalUpdateVersion: '1.10.0',
  },
  ads: {
    banner: {
      enabled: false,
      firstLevel: 1,
      supported: false,
    },
    fallback: {
      xpromoAllowedAndroid: true,
      xpromoAllowedIos: true,
    },
    interstitials: {
      cooldownSeconds: 300,
      enabled: true,
      everyXSeconds: 180,
      firstLevel: 10,
      lossFrequency: 3,
      maxAdsPerSession: 10,
      midLevelEnabled: false,
      onLoss: true,
      onWin: true,
      payerCooldownHours: 168,
      useFacebookFlowForInterstitials: true,
      winFrequency: 2,
    },
  },
  feature: {
    duel: {
      desktopTimeMultiplier: 1.5,
    },
    luckyWheel: {
      adSpins: 2,
    },
    tournament: {
      configUrl: '',
    },
  },
  segment: {
    isTier1: false,
  },
};

export function rawAppRemoteToAppRemote(
  raw: RawAppRemoteConfig,
  base: AppRemoteConfig = baseAppRemote,
): AppRemoteConfig {
  const out = cloneDeep(base);

  Object.keys(raw).forEach((key) => {
    const pathParts = key.split('_');
    let current: Record<string, unknown> = out as unknown as Record<string, unknown>;

    for (let i = 0; i < pathParts.length; i += 1) {
      const part = pathParts[i];
      if (i === pathParts.length - 1) {
        if (hasOwnProperty(current, part)) {
          current[part] = raw[key as keyof RawAppRemoteConfig];
        }
      } else if (typeof current[part] === 'object') {
        current = current[part] as Record<string, unknown>;
      } else {
        return;
      }
    }
  });

  return out;
}
